import {invalidateConsolidateLastRun} from 'modules/store/consolidateLastRun';
import {TAG_CONSOLIDATE_LAST_RUN, changePageTable, changeSort, changeFilter} from 'modules/ui';

export const invalidateLastRun = () => dispatch => {
    const INIT_PAGE = 1;

    dispatch(invalidateConsolidateLastRun());
    dispatch(changePageTable(TAG_CONSOLIDATE_LAST_RUN, INIT_PAGE));
    dispatch(changeSort(TAG_CONSOLIDATE_LAST_RUN, '', true));
    dispatch(changeFilter(TAG_CONSOLIDATE_LAST_RUN, 'search', ''));
};



// WEBPACK FOOTER //
// ./src/modules/consolidateLastRun.js